import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Button } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// actions
import { loadCodesReports, generateCodesReport } from 'ducks/merchantDucks/items/actions';

// selectors
import { getItemCodesReports } from 'ducks/merchantDucks/items/selectors';

// components
import { CustomButton } from 'pages/MerchantPages/Assets/Price/containers/PriceOptions';
import ReportsTable from 'pages/MerchantPages/Assets/Codes/components/ReportsTable';

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
`;

interface Props {
  handleBackToCodesTable: () => void;
}

const AssetCodesReports: FunctionComponent<Props> = ({ handleBackToCodesTable }) => {
  const dispatch = useDispatch();
  const { id: assetId } = useParams<{ id?: string }>();

  const reports = useSelector(getItemCodesReports);

  useEffect(() => {
    dispatch(loadCodesReports(Number(assetId)));
  }, []);

  const handleGenerateRepor = () => {
    dispatch(generateCodesReport(Number(assetId)));
  };

  const renderCodeContent = () => <ReportsTable reports={reports} />;

  return (
    <>
      <ButtonsContainer>
        <CustomButton buttonModifiers={['buttonLink']} type="button" onClick={handleBackToCodesTable}>
          &larr; back
        </CustomButton>
        <Button onClick={handleGenerateRepor}>Generate report</Button>
      </ButtonsContainer>
      {renderCodeContent()}
    </>
  );
};

export default AssetCodesReports;
